import { red } from '@mui/material/colors'
import { createTheme } from '@mui/material/styles'

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#6024D8',
    },
    secondary: {
      main: '#222222',
    },
    error: {
      main: red.A400,
    },
  },
  typography: { 
    fontFamily: ['Open Sans'].join(','),
    h1: {
      fontSize: '3rem', // Default font size for large screens
      '@media (max-width:600px)': { // Small screens
        fontSize: '2rem',
      },
      '@media (max-width:400px)': { // Extra small screens
        fontSize: '1.5rem',
      },
    },
    h2: {
      fontSize: '2.5rem', // Default font size for large screens
      '@media (max-width:600px)': { // Small screens
        fontSize: '1.75rem',
      },
      '@media (max-width:400px)': { // Extra small screens
        fontSize: '1.25rem',
      },
    },
    h3: {
      fontSize: '2rem', // Default font size for large screens
      '@media (max-width:600px)': { // Small screens
        fontSize: '1.5rem',
      },
      '@media (max-width:400px)': { // Extra small screens
        fontSize: '1.25rem',
      },
    },
    h4: {
      fontSize: '1.75rem', // Default font size for large screens
      '@media (max-width:600px)': { // Small screens
        fontSize: '1.25rem',
      },
      '@media (max-width:400px)': { // Extra small screens
        fontSize: '1rem',
      },
    },
    h5: {
      fontSize: '1.5rem', // Default font size for large screens
      '@media (max-width:600px)': { // Small screens
        fontSize: '1.4rem',
      },
      '@media (max-width:400px)': { // Extra small screens
        fontSize: '1.075rem',
      },
    },
    h6: {
      fontSize: '1.25rem', // Default font size for large screens
      '@media (max-width:600px)': { // Small screens
        fontSize: '1.2rem',
      },
      '@media (max-width:500px)': { // Small screens
        fontSize: '1.1rem',
      },
      '@media (max-width:400px)': { // Extra small screens
        fontSize: '0.925rem',
      },
    },
    subtitle1: {
      fontSize: '1rem', // Default font size for large screens
      '@media (max-width:600px)': { // Small screens
        fontSize: '0.975rem',
      },
      '@media (max-width:400px)': { // Extra small screens
        fontSize: '0.80rem',
      },
    },
    subtitle2: {
      fontSize: '0.875rem', // Default font size for large screens
      '@media (max-width:600px)': { // Small screens
        lineHeight: '1.55rem',
        fontSize: '0.75rem',
      },
      '@media (max-width:400px)': { // Extra small screens
        fontSize: '0.625rem',
      },
    },
    body1: {
      fontSize: '0.975rem', // Default font size for large screens
      '@media (max-width:600px)': { // Small screens
        fontSize: '0.95rem',
      },
      '@media (max-width:400px)': { // Extra small screens
        fontSize: '0.80rem',
      },
    },
    body2: {
      fontSize: '0.875rem', // Default font size for large screens
      '@media (max-width:600px)': { // Small screens
        fontSize: '0.8rem',
      },
      '@media (max-width:400px)': { // Extra small screens
        fontSize: '0.625rem',
      },
    },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
      },
      styleOverrides: {
        outlined: {
          textTransform: 'none',
          fontWeight: '600',
          lineHeight: '1.45rem',
          fontSize: '1.05rem',
          borderRadius: 8,
          '@media (max-width:600px)': {
            lineHeight: '1.45rem',
            fontSize: '1.35rem', // Smaller font size for small screens
          },
          '@media (max-width:500px)': {
            lineHeight: '1.65rem',
            fontSize: '1.15rem', // Smaller font size for small screens
          },
          '@media (max-width:400px)': {
            lineHeight: '1.45rem',
            fontSize: '1.075rem', // Even smaller font size for extra small screens
          },
        },
        contained: {
          textTransform: 'none',
          fontWeight: 'bold',
          borderRadius: 8,
          lineHeight: '1.45rem',
          fontSize: '1.25rem',
          // py: 1.5,
          '@media (max-width:600px)': {
            lineHeight: '1.45rem',
            fontSize: '1.35rem', // Smaller font size for small screens
          },
          '@media (max-width:500px)': {
            lineHeight: '1.65rem',
            fontSize: '1.15rem', // Smaller font size for small screens
          },
          '@media (max-width:400px)': {
            lineHeight: '1.45rem',
            fontSize: '1.075rem', // Even smaller font size for extra small screens
          },
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          fontSize: '1.25rem', // Default font size for large screens
          '@media (max-width:600px)': { // Small screens
            fontSize: '1.15rem',
          },
          '@media (max-width:500px)': { // Small screens
            fontSize: '0.95rem',
          },
          '@media (max-width:400px)': { // Extra small screens
            fontSize: '0.775rem',
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontWeight: '600',
          fontSize: '1.0rem', // Default font size for large screens
          '@media (max-width:600px)': { // Small screens
            fontSize: '1.0rem',
          },
          '@media (max-width:500px)': { // Small screens
            fontSize: '0.95rem',
          },
          '@media (max-width:400px)': { // Extra small screens
            fontSize: '0.875rem',
          },
        },
        secondary: {
          fontSize: '0.95rem', // Default font size for secondary text
          color: '#66667a',
          '@media (max-width:600px)': { // Small screens
            fontSize: '0.9rem',
          },
          '@media (max-width:500px)': { // Small screens
            fontSize: '0.85rem',
          },
          '@media (max-width:400px)': { // Extra small screens
            fontSize: '0.800rem',
          },
        },
      },
    },
  },
})

export default theme
